module.exports = __webpack_public_path__ + "img/1.10b7cb0e.png";